/**
 * @generated SignedSource<<e0836988bf673073ad700165cf8b04bc>>
 * @relayHash 9b20bf3de167991b79e58845084ed93d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 52ed34b7e19c1df8ea073010db85d4778763623e22eaeb7b7084649027b50dce

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type mainJiraPermissionSchemeAndGetPermissionSchemeByIdQuery$variables = {
  schemeId: string;
};
export type mainJiraPermissionSchemeAndGetPermissionSchemeByIdQuery$data = {
  readonly jira: {
    readonly viewPermissionScheme: {
      readonly configuration?: {
        readonly isEditable: boolean;
      };
      readonly " $fragmentSpreads": FragmentRefs<"header_permissionScheme">;
    };
  } | null | undefined;
};
export type mainJiraPermissionSchemeAndGetPermissionSchemeByIdQuery = {
  response: mainJiraPermissionSchemeAndGetPermissionSchemeByIdQuery$data;
  variables: mainJiraPermissionSchemeAndGetPermissionSchemeByIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "schemeId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "schemeId",
    "variableName": "schemeId"
  }
],
v2 = {
  "concreteType": "JiraPermissionSchemeConfiguration",
  "kind": "LinkedField",
  "name": "configuration",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isEditable"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "mainJiraPermissionSchemeAndGetPermissionSchemeByIdQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "args": (v1/*: any*/),
              "kind": "LinkedField",
              "name": "viewPermissionScheme",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "header_permissionScheme"
                    },
                    (v2/*: any*/)
                  ],
                  "type": "JiraPermissionSchemeView"
                }
              ]
            },
            "action": "THROW",
            "path": "jira.viewPermissionScheme"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "mainJiraPermissionSchemeAndGetPermissionSchemeByIdQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "kind": "LinkedField",
            "name": "viewPermissionScheme",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "JiraPermissionScheme",
                    "kind": "LinkedField",
                    "name": "scheme",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "name"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "description"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      }
                    ]
                  },
                  (v2/*: any*/)
                ],
                "type": "JiraPermissionSchemeView"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "52ed34b7e19c1df8ea073010db85d4778763623e22eaeb7b7084649027b50dce",
    "metadata": {},
    "name": "mainJiraPermissionSchemeAndGetPermissionSchemeByIdQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "a9a5de7cc43c97f4ccd022fc9a4c4bb4";

export default node;
